var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpSprinklers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(0 -1)",
    style: {
      fill: "var(--bg-color, none)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.049 1.049)",
    style: {
      stroke: "var(--color, #9ea1a2)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.951,
    cy: 39.951,
    r: 39.951,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.951,
    cy: 39.951,
    r: 39.451,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6 40.933H17.067V30.2H13.8v-8.4h20.067v8.4H30.6zM19.167 38.6h9.1V27.867h3.267v-3.734h-15.4v3.733H19.4V38.6z",
    transform: "translate(18.4 16.799)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(39.434 33.465)",
    style: {
      fill: "var(--color, #9ea1a2)"
    },
    d: "M0 0h5.367v3.967H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 26.333H13.8V23.3a9.8 9.8 0 0 1 19.6 0zM16.133 24h14.934v-.7a7.467 7.467 0 1 0-14.933 0z",
    transform: "translate(18.4 5.732)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(28 55.399)",
    style: {
      fill: "var(--color, #9ea1a2)"
    },
    d: "M0 0h28.233v2.333H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.833 21.422H17.5v-2.333h2.333zm0-4.667H17.5v-2.333h2.333zm0-4.667H17.5V9.756h2.333z",
    transform: "translate(23.334 -5.224)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.622 19.983-1.633 1.633-1.633-1.633 1.633-1.633zm-3.267-3.267-1.633 1.634-1.867-1.633 1.633-1.633zm-3.5-3.267-1.633 1.633-1.633-1.632 1.633-1.633z",
    transform: "translate(11.278 -.985)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.933 18.35 1.633 1.633-1.633 1.633-1.633-1.633zm3.267-3.267 1.633 1.633L27.2 18.35l-1.633-1.633zm3.5-3.267 1.633 1.633-1.633 1.634-1.633-1.633z",
    transform: "translate(29.734 -.985)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.333 17.5v2.333H19V17.5zm-4.667 0v2.333h-2.333V17.5zM12 17.5v2.333H9.667V17.5zm-4.667 0v2.333H5V17.5z",
    transform: "translate(6.667 11.065)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9 20.033V17.7h2.333v2.333zm4.667 0V17.7H30.9v2.333zm4.667 0V17.7h2.333v2.333zm4.667 0V17.7h2.333v2.333z",
    transform: "translate(31.867 11.332)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(28.683 55.341)",
    style: {
      fontSize: 21,
      fontWeight: 700,
      letterSpacing: ".025em",
      fill: "var(--color, #9ea1a2)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "MP")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpSprinklers);
export default __webpack_public_path__ + "static/media/mp_sprinklers.a31ccd24c6f6b03ef4345feda575b193.svg";
export { ForwardRef as ReactComponent };